import { scaleFeaturesFrom, type ScaleSourceFeature } from './scaleFeatureSource';
import { bboxFromGeometry } from './vectorScaleBox';

export type VectorFeatureBounds = readonly [number, number, number, number];

/** Return the smallest lon/lat extent containing all supplied feature geometries. */
export function boundsFromVectorFeatures(
  features: ReadonlyArray<ScaleSourceFeature>,
): VectorFeatureBounds | null {
  let bounds: VectorFeatureBounds | null = null;
  for (const feature of scaleFeaturesFrom(features)) {
    const bbox = bboxFromGeometry(feature.geometry);
    if (!bbox) continue;
    bounds = bounds
      ? [
          Math.min(bounds[0], bbox.minX),
          Math.min(bounds[1], bbox.minY),
          Math.max(bounds[2], bbox.maxX),
          Math.max(bounds[3], bbox.maxY),
        ]
      : [bbox.minX, bbox.minY, bbox.maxX, bbox.maxY];
  }
  return bounds;
}
